/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from "react";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";
import utils from "@utils";
import classNames from "classnames";
import "./OrganizationFeesModal.scss";

const ModifyRate = props => {
	const { lang } = global;
	const { rateHistory, feeTypeId, onSaveFee, showCreatedBy } = props;
	const dateMask = [/[0-1]/, /[0-9]/, "/", /[0-3]/, /[0-9]/, "/", /2/, /0/, /[2-9]/, /[0-9]/];
	const [Rate, setRate] = useState("");
	const [EffectiveFrom, setEffectiveFrom] = useState("");
	const [errors, setErrors] = useState({ Rate: "", EffectiveFrom: "" });
	const [loading, setLoading] = useState(false);

	const handleChange =
		field =>
		({ target: { value } }) => {
			if (field === "Rate" && !value.match(/^\d*\.?\d{0,2}$/g)) return;
			if (field === "Rate") {
				setRate(value);
			} else if (field === "EffectiveFrom") {
				setEffectiveFrom(value);
			}
		};

	/** Saves the changes made to organization rates */
	const saveRate = () => {
		const callback = (failed = false) => {
			if (failed) {
				setLoading(false);
			} else {
				setRate("");
				setEffectiveFrom("");
				setErrors({ Rate: "", EffectiveFrom: "" });
				setLoading(false);
			}
		};
		setLoading(true);
		const errs = {};
		if (Number.isNaN(parseFloat(Rate))) {
			errs.Rate = "Invalid percentage value.";
			setLoading(false);
		}
		if (Number.isNaN(new Date(`${EffectiveFrom} 00:00:00`).getTime())) {
			errs.EffectiveFrom = "Invalid date entered.";
			setLoading(false);
		}
		if (Object.keys(errs).length === 0) {
			const form = {
				TypeId: feeTypeId,
				Rate: parseFloat(Rate),
				EffectiveFrom: new Date(new Date(`${EffectiveFrom} 00:00:00`).getTime())
					.toISOString()
					.slice(0, -1),
			};
			onSaveFee(form, callback);
		} else {
			setErrors(errs);
		}
	};

	return (
		<div className="add-fee-section">
			<div className="row">
				<div className="col-sm-4 form-group">
					<label htmlFor="newRate">
						{lang.t("New Rate")} (%)
						<input
							className="form-control"
							name="newRate"
							id="newRate"
							type="tel"
							value={Rate}
							onChange={handleChange("Rate")}
						/>
					</label>
					<div className="text-danger">{errors.Rate}</div>
				</div>
				<div className="col-sm-4 form-group">
					<label htmlFor="newEffectiveDate">
						{lang.t("Effective Date")}
						<Choose>
							<When condition={utils.isDesktopSafari || utils.isIE}>
								<MaskedInput
									name="newEffectiveDate"
									id="newEffectiveDate"
									type="text"
									mask={dateMask}
									className="form-control"
									placeholder="mm/dd/yyyy"
									value={EffectiveFrom}
									onChange={handleChange("EffectiveFrom")}
								/>
							</When>
							<Otherwise>
								<input
									name="newEffectiveDate"
									id="newEffectiveDate"
									className="form-control"
									type="date"
									value={EffectiveFrom}
									onChange={handleChange("EffectiveFrom")}
								/>
							</Otherwise>
						</Choose>
					</label>
					<div className="text-danger">{errors.EffectiveFrom}</div>
				</div>
				<div className="edit-fee-btn">
					<div className="col-sm-4">
						<button
							type="button"
							className="btn btn-primary"
							onClick={saveRate}
						>
							{loading ? "Adding..." : "Add"}
						</button>
					</div>
				</div>
			</div>
			<div className="row">
				<div
					className={classNames({
						"col-xs-3": showCreatedBy,
						"col-xs-4": !showCreatedBy,
					})}
				>
					<strong>{lang.t("Rate")}</strong>
				</div>
				<div
					className={classNames({
						"col-xs-3": showCreatedBy,
						"col-xs-4": !showCreatedBy,
					})}
				>
					<strong>{lang.t("Effective Date")}</strong>
				</div>
				<If condition={showCreatedBy}>
					<div className="col-xs-4">
						<strong>{lang.t("Created By")}</strong>
					</div>
				</If>
			</div>
			<div className="history-fee-list">
				{rateHistory.map(item => (
					<div
						className="row"
						key={`rkpay-rate-history-${item.Id}`}
					>
						<div
							className={classNames({
								"col-xs-3": showCreatedBy,
								"col-xs-4": !showCreatedBy,
							})}
						>{`${item.Rate}%`}</div>
						<div
							className={classNames({
								"col-xs-3": showCreatedBy,
								"col-xs-4": !showCreatedBy,
							})}
						>
							<If condition={item.EffectiveFrom !== null}>
								{new Date(`${item.EffectiveFrom}Z`).toLocaleString(undefined, {
									month: "numeric",
									day: "numeric",
									year: "numeric",
								})}
							</If>
						</div>
						<If condition={showCreatedBy}>
							<div className="col-xs-4">{item.CreatedByUserEmail}</div>
						</If>
					</div>
				))}
			</div>
		</div>
	);
};

ModifyRate.propTypes = {
	rateHistory: PropTypes.array,
	feeTypeId: PropTypes.number.isRequired,
	onSaveFee: PropTypes.func,
	showCreatedBy: PropTypes.bool,
};

ModifyRate.defaultProps = {
	rateHistory: [],
	onSaveFee: () => {},
	showCreatedBy: false,
};

export default ModifyRate;
